import 'jquery-validation';

$.validator.addMethod("validTime", function(value, element) {
    // Ellenőrzés, hogy a dátum és idő helyes formátumban van (YYYY-MM-DD HH:mm)
    const dateTimePattern = /^\d{4}-\d{2}-\d{2} ([01]\d|2[0-3]):([0-5]\d)$/; // YYYY-MM-DD HH:mm
    if (!dateTimePattern.test(value)) {
        return false; // Ha nem megfelelő az időpont formátuma, nem érvényes
    }

    // Szétbontjuk a dátumot és az időt
    const [date, time] = value.split(" ");
    const [hours, minutes] = time.split(":").map(Number);

    // Ellenőrizzük, hogy 7:00 és 22:00 között van-e az időpont
    return (hours > 6 && hours < 22) || (hours === 22 && minutes === 0);
}, "Kérlek, add meg a vásárlás pontos időpontját!");

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $("#contactForm").validate({
        // debug: true,
        ignore: ".ignore",
        errorClass: 'is-invalid',  // Bootstrap class to show invalid inputs
        validClass: 'valid',    // Bootstrap class for valid inputs
        errorElement: 'div',       // Use a div element for error messages
        errorPlacement: function (error, element) {
            // Find the next sibling that has 'invalid-feedback' class
            error.addClass('invalid-feedback'); // Bootstrap error message class
            if (element.closest('.form-group').find('.invalid-feedback').length) {
                element.closest('.form-group').find('.invalid-feedback').replaceWith(error);
            } else {
                element.closest('.form-group').append(error);
            }
        },
        highlight: function (element) {
            $(element).addClass('is-invalid').removeClass('valid'); // Apply invalid class to input
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid').addClass('valid'); // Apply valid class to input
            // $(element).closest('.form-group').find('.invalid-feedback').remove();
        },
        rules: {
            firstname: {
                required: true,
                maxlength: 191
            },
            lastname: {
                required: true,
                maxlength: 191
            },
            email: {
                required: true,
                email: true,
                maxlength: 191
            },
            zip: {
                number: true,
                digits: true,  // Pontosan számokat vár
                minlength: 4,  // 4 számjegy
                maxlength: 4   // 4 számjegy
            },
            amount: {
                required: true,
                number: true,
                min: 5000
            },
            purchase_time: {
                required: true,
                validTime: true
            },
            phone: {
                required: true,
            },
            message: {
                required: true,
            },
            ap_code: {
                required: true,
            },
            shop: {
                required: true
            },
            privacy_policy: {
                required: true
            },
            accept_game: {
                required: true
            }
        },
        messages: {
            firstname: {
                required: "Kérlek, add meg a keresztneved!",
                maxlength: "Nem lehet hosszabb 191 karakternél."
            },
            lastname: {
                required: "Kérlek, add meg a vezetékneved!",
                maxlength: "Nem lehet hosszabb 191 karakternél."
            },
            email: {
                required: "Kérlek, add meg az e-mail címed!",
                email: "Érvénytelen e-mail cím."
            },
            phone: {
                required: "Kérlek, add meg a telefonszámod!",
            },
            message: {
                required: "Kérlek, írd le röviden, hogy miben segíthetünk!",
            },
            zip: {
                min: "Az irányítószámnak 4 számjegyből kell állnia.",
                max: "Az irányítószámnak 4 számjegyből kell állnia.",
                required: "Az irányítószám megadása kötelező!",
                digits: "Az irányítószám csak számokat tartalmazhat.",
                minlength: "Az irányítószámnak 4 számjegyből kell állnia.",
                maxlength: "Az irányítószámnak 4 számjegyből kell állnia."
            },
            amount: {
                required: "Kérlek, add meg a vásárlás összegét!",
                min: "Nem lehet kisebb mint 5000 Ft.",
                max: "Nem lehet kisebb mint 2000000000 Ft."
            },
            ap_code: {
                required: "Az AP kód megadása kötelező!",
                minlength: "Az AP kód pontosan 9 karakter hosszú kell legyen.",
                maxlength: "Az AP kód pontosan 9 karakter hosszú kell legyen.",
                remote: "Ez az AP kód és vásárlási idő már létezik."
            },
            purchase_time: {
                required: "Kérlek, add meg a vásárlás időpontját!",
            },
            shop: {
                required: "Kérlek, válassz egy üzletet!"
            },
            privacy_policy: {
                required: "Kérlek, fogadd el az adatvédelmi szabályzatot!"
            },
            accept_game: {
                required: "Kérlek, fogadd el a játék szabályzatát!"
            }
        },
        submitHandler: function (form) {
            form.submit();
        }
    });

    $("#mailchimpForm").validate({
        // debug: true,
        ignore: ".ignore",
        errorClass: 'is-invalid',  // Bootstrap class to show invalid inputs
        validClass: 'valid',    // Bootstrap class for valid inputs
        errorElement: 'div',       // Use a div element for error messages
        errorPlacement: function (error, element) {
            console.log("error");
            // Find the next sibling that has 'invalid-feedback' class
            error.addClass('invalid-feedback'); // Bootstrap error message class
            if (element.closest('.form-group').find('.invalid-feedback').length) {
                element.closest('.form-group').find('.invalid-feedback').replaceWith(error);
            } else {
                element.closest('.form-group').append(error);
            }
        },
        highlight: function (element) {
            $(element).addClass('is-invalid').removeClass('valid'); // Apply invalid class to input
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid').addClass('valid'); // Apply valid class to input
            // $(element).closest('.form-group').find('.invalid-feedback').remove();
        },
        rules: {
            firstname: {
                required: true,
                maxlength: 191
            },
            lastname: {
                required: true,
                maxlength: 191
            },
            email: {
                required: true,
                email: true,
                maxlength: 191
            },
            privacy_policy: {
                required: true
            }
        },
        messages: {
            firstname: {
                required: "Kérlek, add meg a keresztneved!",
                maxlength: "Nem lehet hosszabb 191 karakternél."
            },
            lastname: {
                required: "Kérlek, add meg a vezetékneved!",
                maxlength: "Nem lehet hosszabb 191 karakternél."
            },
            email: {
                required: "Kérlek, add meg az e-mail címed!",
                email: "Érvénytelen e-mail cím."
            },
            privacy_policy: {
                required: "Kérlek, fogadd el az adatvédelmi szabályzatot!"
            }
        },
        submitHandler: function (form) {
            $("#subscribeButton").prop('disabled', true);
            form.submit();
        }
    });
});
